import { Trash2 } from 'lucide-react'

import { useDeleteUser } from 'query/useUsers'
import { ConfirmNameModal, Icon, IconButton } from 'ui'

const DeleteUserConfirmModal = ({
  children,
  id,
  name,
  onDeleteSuccess = () => {},
}) => {
  const { mutateAsync, isPending: isDeletePending } = useDeleteUser()

  const handleConfirm = async () => {
    await mutateAsync({
      endpointParams: { id },
    })

    onDeleteSuccess()
  }

  return (
    <ConfirmNameModal
      actionLabel="Delete"
      actionPendingLabel="Deleting…"
      confirmationAction="delete this user"
      confirmationButtonLabel="Delete"
      isPending={isDeletePending}
      name={name}
      onConfirm={handleConfirm}
      title="Delete User"
      trigger={children || (
        <IconButton label={`Delete ${name}`} variant="danger">
          <Icon as={Trash2} />
        </IconButton>
      )}
    >
      If you delete this user they will become unlicensed immediately.
    </ConfirmNameModal>
  )
}

export default DeleteUserConfirmModal
